import {Component, Input, OnInit} from '@angular/core';
import {NzMessageService} from 'ng-zorro-antd/message';
import {FormGroup, FormControl} from '@angular/forms';
import {ClipboardService} from 'ngx-clipboard';
import {UploadXHRArgs} from "ng-zorro-antd";
import {AppConfigService} from "../../service/app-config.service";
import {UploadService} from "../../service/upload.service";
import {RequestDataService} from "../../service/request-data.service";
import {ConfirmModalService} from "../../service/confirm-modal.service";
import {DataCenterService} from "../../service/data-center.service";
import * as _ from 'lodash';
import PubSub from 'pubsub-js';
import {UtilsService} from "../../service/utils.service";
import {UserInfoService} from "../../service/user-info.service";

@Component({
    selector: 'app-loading-expenditure',
    templateUrl: './loading-expenditure.component.html',
    styleUrls: ['./loading-expenditure.component.scss'],
})
export class loadingExpenditureComponent implements OnInit {
    @Input() parentData: any;

    constructor(
        private confirmModal: ConfirmModalService,
        private requestService: RequestDataService,
        private dataCenterService: DataCenterService,
        private utils: UtilsService,
        private appConfigService: AppConfigService,
        private uploadService: UploadService,
        private msg: NzMessageService,
        private userInfoService: UserInfoService,
        private clipboardService: ClipboardService
    ) {
    }

    public fileList: any = [];
    public importState: boolean = false;//false表示未开始导入
    public fileUrl: string = null;
    public filterErr: boolean = false;
    public filterMatch: boolean = false;
    public dataSetFilter: any = [];// 过滤后的数据
    public modeType: any; // trans 运输收入结算导入; loadUnload 装卸收入结算导入;
    //一开始请求到的数据
    public dataSet: any = [];
    public lastFileUrl: string = null; // 记录已全量解析的文件（判断刷新时是否需要重新解析）
    public isDeductTax: boolean = false; // 剔税标记：开则导入收入 ×(1+税率)
    public taxRate: number = 0.09; // 税率（默认 0.09）
    // 客户选择（trans 模式使用，poplist 组件）
    public custForm: FormGroup;
    public custColumn: any = {
        'column': 'CUST_ID',
        'name': 'CUST_ID_NAME',
        'component': 'poplist',
        'lable': '客户',
        'comment': '客户',
        'placeholder': '请选择客户（可选）',
        'modelName': '',
        'model': null,
        'visible': true,
        'require': true,
        'dictionary': 'JieLiv2/basic/dict/BASIC_CUST.json',
        'dictionaryPF': null
    };
    private oldCustId: any = null; // 用于 ngDoCheck 检测客户变化
    // public isIncludeTax: boolean = false; // 含税标记，nz-switch 使用 boolean
    // public settlementIncludeTax: number = 0; // 0 不含税，1 含税，传给后端

    beforeUpload = (file: File) => {
        const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        if (!isXLSX) {
            this.msg.error('You can only upload xlsx file!');
        }
        return isXLSX;
    }

    customReq = (item: UploadXHRArgs) => {
        this.importState = true;
        if (this.appConfigService.config['userOssOrCos'] === 'COS') {
            return this.uploadService.doCosUpload(item.file, item['progress'], null, null, null).then((result) => {
                item.onSuccess({}, item.file, event);
                this.fileUrl = this.appConfigService.config['COS']['domain'] + '/' + result['url'];
                this.getImportData();
            });
        } else {
            return this.uploadService.doAliOssUpload(item.file, item['progress'], null).then((result) => {
                item.onSuccess({}, item.file, event);
                this.fileUrl = this.appConfigService.config['OSS']['domain'] + '/' + result.name;
                this.getImportData();
            });
        }
    }

    changeFileList = (result) => {
        if (result.type === 'success' && result.fileList.length === 2) {
            // 只传一个文件
            result.fileList.splice(0, 1);
        }
    }

    async getImportData() {
        if (!this.utils.Base_HasValue(this.fileUrl)) {
            this.confirmModal.show('error', {'title': '执行成功错误如下', 'content': '请先选择Excel文件。'});
            return;
        }
        // 运输收入结算导入：客户为必填项
        if (this.modeType === 'trans' && !this.utils.Base_HasValue(this.custColumn.model)) {
            this.confirmModal.show('error', {'title': '错误', 'content': '请先选择客户！'});
            return;
        }
        const startTime = performance.now();
        let res = null;
        if (this.modeType === 'loadUnload') {
            res = await this.requestService.doActionByHdbsthor('AppApi/LAndUExpenditureController', 'verificationOfLoadingAndUnloadingRevenue', {fileUrl: this.fileUrl}, null, false, 'hdbsthor_JieLiv2', 'appToken').toPromise();
        } else if (this.modeType === 'trans') {
            if (this.lastFileUrl === this.fileUrl && this.dataSet.length > 0) {
                // 系统数据可能有更新：只重新比对（不重新下载/解析Excel），body 传已解析的记录
                res = await this.requestService.doActionByHdbsthor('AppApi/MsTranOrdersController', 'verificationOfTransRevenueCheck', {custId: this.custColumn.model}, this.dataSet, false, 'hdbsthor_JieLiv2', 'appToken').toPromise();
            } else {
                res = await this.requestService.doActionByHdbsthor('AppApi/MsTranOrdersController', 'verificationOfTransRevenue', {fileUrl: this.fileUrl, custId: this.custColumn.model, deductTax: this.isDeductTax, taxRate: this.taxRate}, null, false, 'hdbsthor_JieLiv2', 'appToken').toPromise();
                this.lastFileUrl = this.fileUrl;
            }
        }
        if (res.length > 0) {
            this.dataSet = res;// 这是请求到的数据
            this.dataSetFilter = this.dataSet;//表格数据，一开始就给全部数据到表格
            this.filterMatch = false;
            this.filterErr = false;
            const endTime = performance.now();
            this.confirmModal.show('success', {'title': '执行成功', 'content': '耗时 '+ ((endTime - startTime) / 1000) .toFixed(3) +' 秒。'});
        } else {
            this.confirmModal.show('error', {
                'title': '执行失败',
                content: res.error.message
            });
        }
    }

    checkError(){
        if (!this.utils.Base_HasValue(this.fileUrl)) {
            this.confirmModal.show('error',
                {title: '错误', content: '请先上传Excel'});
            return;
        }
        // 运输收入结算导入：客户为必填项
        if (this.modeType === 'trans' && !this.utils.Base_HasValue(this.custColumn.model)) {
            this.confirmModal.show('error',
                {title: '错误', content: '请先选择客户！'});
            return;
        }
        // "无此单号"/"订单未提交"的记录允许继续保存（后端会按相同格式落库），但保存前需单独询问
        // 注意：这两种状态必须用 matches 判定。后端 errors 是多值拼接字段（如"订单未提交；收货节点未匹配：xxx"），
        // 用 errors 精确相等匹配会漏判，导致本该放行的记录被当成硬错误拦截。
        let errorCount = this.dataSet.filter(item => item.errors != null && item.matches !== '无此单号' && item.matches !== '订单未提交').length;
        if (errorCount > 0) {
            this.confirmModal.show('error',
                {title: '错误', content: '存在错误记录，请过滤查看！'});
            return;
        }
        // 存在未匹配客户订单的记录 → 询问是否新增保存
        const unmatchedCount = this.dataSet.filter(item => item.matches === '无此单号' || item.matches === '订单未提交').length;
        if (unmatchedCount > 0) {
            this.confirmModal.show('confirm', {
                title: '温馨提示',
                content: '存在' + unmatchedCount + '条未匹配客户订单的记录，是否新增保存？',
                suc: () => {
                    this.confirmUnmatchedSave();
                }
                // 选择"否"：不执行任何操作，停止保存
            });
            return;
        }
        this.confirmUnmatchedSave();
    }

    // 确认新增"无此单号"记录后，继续原有保存流程（可能还有"不相符"确认）
    confirmUnmatchedSave(){
        const errorCount = this.dataSet.filter(item => item.matches != "相符").length;
        if (errorCount > 0) {
            // checkErrorCount = false;
            this.confirmModal.show('confirm', {
                title: '温馨提示',
                content: '存在不相符记录，共' + errorCount + '条，确定保存导入的收入数据？',
                suc: () => {
                    this.verifyClicked();
                }
            });
        } else {
            this.verifyClicked();
        }
    }

    async verifyClicked() {
        let response = null;
        const startTime = performance.now();
        if (this.modeType === 'loadUnload') {
            // 处理核对按钮的逻辑
            let queryData = {
                'fileUrl': this.fileUrl,
                'userId': this.userInfoService.getUserInfo().USER_ID
            };
            response = await this.requestService.doActionByHdbsthor('AppApi/LAndUExpenditureController', 'check', queryData, null, false, 'hdbsthor_JieLiv2', 'appToken').toPromise();
        } else if (this.modeType === 'trans') {
            let queryData = {
                'fileUrl': this.fileUrl,
                'userId': this.userInfoService.getUserInfo().USER_ID,
                'custId': this.custColumn.model,
                'deductTax': this.isDeductTax,
                'taxRate': this.taxRate
            };
            response = await this.requestService.doActionByHdbsthor(
                'AppApi/MsTranOrdersController',
                'check',
                queryData,
                this.dataSet,   // body：前端已解析的记录，避免后端重新下载/解析Excel
                false,
                'hdbsthor_JieLiv2',
                'appToken'
            ).toPromise();
        }

        if (response == true) {
            const endTime = performance.now();
            this.confirmModal.show('success', {'title': '执行成功', 'content': '耗时 '+ ((endTime - startTime) / 1000) .toFixed(3) +' 秒。'});
            this.closePage();
        } else {
            this.confirmModal.show('error', {'title': '执行成功错误如下', 'content': response.error.message});
        }
    }

    closePage() {
        let menuId = _.get(this.parentData, ['nowMenu', 'MENU_ID'], null);
        if (this.utils.Base_HasValue(menuId)) {
            PubSub.publish('listRefresh', menuId);
        }
        this.dataCenterService.closeTab(this.parentData);
    }

    downloadTemplate() {
        if (this.modeType === 'loadUnload') {
            window.location.href = `${this.appConfigService.config.NodeJsServer}/JieLiv2/import/装卸收入结算导入模版V1.0_20230815.xlsx`;
        } else if (this.modeType === 'trans') {
            window.location.href = `${this.appConfigService.config.NodeJsServer}/JieLiv2/import/运输收入结算导入模版V1.0_20230829.xlsx`;
        }
    }


    ngOnInit() {
        this.modeType = _.get(this.parentData, ['modeType'], 'loadUnload');
        this.custForm = new FormGroup({'CUST_ID_NAME': new FormControl(null)});
    }

    // 监听客户选择变化（poplist 无 change 事件，用 ngDoCheck 检测 model 变化）
    ngDoCheck() {
        const custId = this.custColumn.model;
        if (custId !== this.oldCustId) {
            this.oldCustId = custId;
            this.onCustChange();
        }
    }

    // 切换客户后重新匹配（已有导入文件时自动刷新）
    onCustChange() {
        if (this.utils.Base_HasValue(this.fileUrl)) {
            this.getImportData();
        }
    }

    // 复制未提交订单号：收集列表中"订单未提交"记录的客户订单号到剪贴板
    // 用 matches 判定：errors 会被后端拼接（如"订单未提交；收货节点未匹配：xxx"），精确相等匹配会永远不成立
    copyUnsubmittedOrders() {
        const unsubmitted = this.dataSet.filter(item => item.matches === '订单未提交' && this.utils.Base_HasValue(item.tranCustCode));
        if (unsubmitted.length === 0) {
            this.confirmModal.show('error', {title: '提示', content: '没有"订单未提交"的记录'});
            return;
        }
        const text = unsubmitted.map(item => item.tranCustCode).join('\n');
        this.clipboardService.copyFromContent(text);
        this.confirmModal.show('success', {
            title: '成功',
            content: '已复制 ' + unsubmitted.length + ' 个未提交订单号，可直接粘贴（Ctrl+V）'
        });
    }

    // onTaxSwitchChange(checked: boolean) {
    //     this.settlementIncludeTax = checked ? 1 : 0;
    // }

    //过滤器
    filterErrorData() {
        if (this.filterErr && this.filterMatch) {
            this.dataSetFilter = this.dataSet.filter(item => (item.matches != "相符" && item.errors !=null));
        } else if (this.filterMatch){
            this.dataSetFilter = this.dataSet.filter(item => (item.matches != "相符"));
        } else if (this.filterErr){
            this.dataSetFilter = this.dataSet.filter(item => (item.errors !=null));
        } else {
            this.dataSetFilter = this.dataSet;
        }
    }
}
